module.exports = __webpack_public_path__ + "static/kozulj-thumbnail-7023f58105e6800270c22747b06d2032.jpg";